import { render, staticRenderFns } from "./ConfirmNewPassword.vue?vue&type=template&id=63fb2082&scoped=true"
import script from "./ConfirmNewPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmNewPassword.vue?vue&type=script&lang=js"
import style0 from "./ConfirmNewPassword.vue?vue&type=style&index=0&id=63fb2082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb2082",
  null
  
)

export default component.exports